var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9h1v1H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6v9h17V6zm3 8H1v-2h1v1h1zm0-6H2v1H1V7h2zm7.5 2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H9v.5a.5.5 0 0 1-1 0V13H6.5a.5.5 0 0 1 0-1H8v-1H6.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H8v-.5a.5.5 0 0 1 1 0V8h1.5a.5.5 0 0 1 0 1H9v1zm5.5 4h-2v-1h1v-1h1zm0-5h-1V8h-1V7h2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11h1v1H9zM1 4h15v1.5H1zM2 2h13v1.5H2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cash.svg";